/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */

export interface ResetPasswordOldDTO {
  /** Confirm new password (must match the password field) */
  confirmPassword: string;
  /** New password */
  password: string;
  /** Reset token required for password reset */
  token: string;
  /** User policy ID (optional) */
  userPolicyId?: string;
}
